/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerRouteTrafficQuery($customerId: ID!, $startDate: DateTime, $endDate: DateTime, $countryNameToSearch: String, $mccToSearch: String) {
  CustomerRouteTraffic(customerId: $customerId, startDate: $startDate, endDate: $endDate, countryNameToSearch: $countryNameToSearch, mccToSearch: $mccToSearch) {
    _report
    _routeTotals
    message
    status
  }
}
`
